export enum SurfaceType {
    Both,
    Wall,
    Floor
}